import { ApiParameters } from "./api-parameters";
import { ApiPutRequest } from "./api-put-request";

export class NetaxeptFinalizeRequest extends ApiPutRequest
{
    public constructor(transactionId, webapiBasepath: string) {
        super('nets/netaxept-finalize-transaction', new ApiParameters(), null, { transactionId }, webapiBasepath);
    }
}